import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnDestroy,
	Output,
	ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import SignaturePad from 'signature_pad';

@Component({
	selector: 'app-signature-pad',
	templateUrl: './signature-pad.component.html',
	standalone: false,
})
export class SignaturePadComponent implements AfterViewInit, OnDestroy {
	@ViewChild('canvas') canvasEl!: ElementRef;
	signaturePad!: SignaturePad;
	@Input() signatureImg: string;
	@Input() showSaveButton = false;
	@Output() signatureImgChange: EventEmitter<string> =
		new EventEmitter<string>();
	@Output() saveClick: EventEmitter<void> = new EventEmitter<void>();
	private resizeSubscription;
	public isDrawing = false;

	@HostListener('document:pointerup', ['$event'])
	onPointerUp(ev: KeyboardEvent) {
		if (this.isDrawing) {
			const base64Data = this.signaturePad.toDataURL();
			this.signatureImg = base64Data;
			this.signatureImgChange.emit(base64Data);
			this.isDrawing = false;
		}
	}

	ngAfterViewInit() {
		const resizeObservable = new Observable((observer) => {
			const resizeObserver = new ResizeObserver((entries) => {
				for (const entry of entries) {
					observer.next(entry.contentRect);
				}
			});
			resizeObserver.observe(this.canvasEl.nativeElement);
			return () => resizeObserver.disconnect();
		});

		this.resizeSubscription = resizeObservable
			.pipe(debounceTime(20))
			.subscribe((rect) => {
				this.adjustCanvasSize(rect);
			});
	}

	ngOnDestroy() {
		this.resizeSubscription?.unsubscribe();
	}

	adjustCanvasSize(rect) {
		const ratio = window.devicePixelRatio || 1;
		this.canvasEl.nativeElement.style.width = '100%';
		this.canvasEl.nativeElement.style.height = 'auto';
		this.canvasEl.nativeElement.width = rect.width * ratio;
		this.canvasEl.nativeElement.height = rect.height * ratio;
		this.canvasEl.nativeElement.getContext('2d').scale(ratio, ratio);
		this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
		if (this.signatureImg)
			this.signaturePad.fromDataURL(this.signatureImg, {
				width: rect.width,
				height: rect.height,
			});
	}

	startDrawing() {
		this.isDrawing = true;
	}

	clearPad() {
		this.signaturePad.clear();
		this.signatureImg = '';
		this.signatureImgChange.emit('');
	}

	save() {
		this.saveClick.emit();
	}
}
